import { Component, createRef } from "react";
import { IBaseComponentProps, NSBoxEntity } from "namirasoft-site-react";
import { RoleRow } from "namirasoft-access";
import { AccessProps } from "../AccessProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SortItem } from "namirasoft-core";

export interface RoleLineProps extends IBaseComponentProps, NSARouterMakerResult, AccessProps
{
	index: number;
	deletable: boolean;
	fullWidth?: boolean;
	onDelete: () => void;
	onChanged?: (value: any) => void;
}

export default class RoleLine extends Component<RoleLineProps>
{
	static EMPTY()
	{
		return "";
	}
	static IS_DIRTY(value: any): boolean
	{
		if (value)
			return true;
		return false;
	}

	private NSBoxEntity_Role = createRef<NSBoxEntity<RoleRow>>();

	constructor(props: RoleLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError?: boolean): string
	{
		return this.NSBoxEntity_Role.current?.getValueOne(checkError) ?? "";
	}

	setValue(value: string)
	{
		this.NSBoxEntity_Role.current?.setValue(value);
	}

	isDirty(): boolean
	{
		return RoleLine.IS_DIRTY(this.getValue());
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue());
	}

	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		return (
			<NSBoxEntity<RoleRow>
				ref={this.NSBoxEntity_Role}
				{...this.props}
				title={`Role ${this.props.index + 1}`}
				required={false}
				multiple={false}
				table={namirasoft.access.tables.role}
				getValue={item => item.id}
				getTitle={item =>
				{
					return item.name + (item.user_id == null ? " (Global)" : "");
				}}
				getSort={() =>
				{
					return new SortItem(namirasoft.access.tables.role, namirasoft.access.tables.role.columns.name, true);
				}}
				onChanged={this.onChanged}
				style={{ ...this.props.style, width: "100%" }}
				menu={{
					builtin: {
						delete: {
							enabled: this.props.deletable,
							onDelete: () => { this.props.onDelete(); }
						}
					},
					items: []
				}}
			/>
		);
	}
}